export default __webpack_public_path__ + "static/media/admin1.09788724.png";